var _circle, _g, _g2, _path, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinances(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 434,
    height: 434,
    viewBox: "0 0 434 434",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 217,
    cy: 217,
    r: 217,
    fill: "#D0ECE7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_df_5363_18058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235 115L214 92L212.5 115.5L235 115Z",
    fill: "#F7ECE8",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 95C85 92.7909 86.7909 91 89 91H211C213.209 91 215 92.7909 215 95V108C215 111.314 217.686 114 221 114H232C234.209 114 236 115.791 236 118V292.033C236 294.232 234.225 296.018 232.026 296.032L89.0261 296.967C86.8068 296.982 85 295.187 85 292.967V95Z",
    fill: "#F7ECE8",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113,
    y1: 275,
    x2: 227,
    y2: 275,
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113,
    y1: 261,
    x2: 227,
    y2: 261,
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113,
    y1: 247,
    x2: 227,
    y2: 247,
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.564 178.49V123.106C191.121 123.106 215.898 147.903 215.898 178.494C215.898 184.611 215.079 189.79 213.19 195.61L160.568 178.494L160.564 178.49Z",
    fill: "#F8815C",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.564 178.49L107.941 161.378C115.496 138.102 136.118 123.106 160.564 123.106V178.494V178.49Z",
    fill: "#4EB072",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.564 178.489L107.941 195.605C104.164 183.969 104.164 173.013 107.941 161.374L160.564 178.489Z",
    fill: "#6BC2D6",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.564 178.489L213.186 195.605C203.743 224.696 172.528 240.619 143.464 231.166C126.025 225.495 113.603 213.061 107.937 195.605L160.56 178.489H160.564Z",
    fill: "#FAB39D",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_df_5363_18058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295 155L274 132L272.5 155.5L295 155Z",
    fill: "#F7ECE8",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 135C145 132.791 146.791 131 149 131H271C273.209 131 275 132.791 275 135V148C275 151.314 277.686 154 281 154H292C294.209 154 296 155.791 296 158V332.033C296 334.232 294.225 336.018 292.026 336.032L149.026 336.967C146.807 336.982 145 335.187 145 332.967V135Z",
    fill: "#F7ECE8",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163,
    y1: 309,
    x2: 277,
    y2: 309,
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163,
    y1: 295,
    x2: 277,
    y2: 295,
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163,
    y1: 268,
    x2: 277,
    y2: 268,
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173,
    y: 176,
    width: 25,
    height: 92,
    fill: "#FAB39D",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 221,
    width: 25,
    height: 47,
    fill: "#6BC2D6",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 176,
    width: 25,
    height: 92,
    fill: "#4EB072",
    stroke: "#102D3E",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5363_18058",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 192,
    y: 163,
    width: 137,
    height: 137
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328 231.5C328 268.779 297.779 299 260.5 299C223.221 299 193 268.779 193 231.5C193 194.221 223.221 164 260.5 164C297.779 164 328 194.221 328 231.5Z",
    fill: "#0999B9",
    stroke: "#102D3E",
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5363_18058)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5363_18058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 95C85 92.7909 86.7909 91 89 91H211C213.209 91 215 92.7909 215 95V108C215 111.314 217.686 114 221 114H232C234.209 114 236 115.791 236 118V292.033C236 294.232 234.225 296.018 232.026 296.032L89.0261 296.967C86.8068 296.982 85 295.187 85 292.967V95Z",
    fill: "#F7ECE8",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113,
    y1: 275,
    x2: 227,
    y2: 275,
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113,
    y1: 261,
    x2: 227,
    y2: 261,
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113,
    y1: 247,
    x2: 227,
    y2: 247,
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.564 178.49V123.106C191.121 123.106 215.898 147.903 215.898 178.494C215.898 184.611 215.079 189.79 213.19 195.61L160.568 178.494L160.564 178.49Z",
    fill: "#F8815C",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.564 178.489L213.186 195.605C203.743 224.696 172.528 240.619 143.464 231.166C126.025 225.495 113.603 213.061 107.937 195.605L160.56 178.489H160.564Z",
    fill: "#FAB39D",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 101.013C120 98.804 121.791 97.0132 124 97.0132H289.137C291.346 97.0132 293.137 98.804 293.137 101.013V121.53C293.137 124.843 295.824 127.53 299.137 127.53H317C319.209 127.53 321 129.32 321 131.53V365.693C321 367.892 319.225 369.678 317.026 369.693L124.026 370.954C121.807 370.969 120 369.174 120 366.954V101.013Z",
    fill: "#F7ECE8",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.209,
    y1: 279.438,
    x2: 295.464,
    y2: 279.438,
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.588,
    y: 216.425,
    width: 33.8235,
    height: 63.0131,
    fill: "#6BC2D6",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 233,
    width: 34,
    height: 46,
    fill: "#4EB072",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.37 197.113C275.065 194.399 273.974 192.394 272.106 191.155C270.592 190.191 269.028 189.719 267.386 189.719C267.013 189.719 266.62 189.749 266.246 189.798C262.185 190.25 258.213 193.249 258.577 198.922C258.577 199.541 258.577 200.19 258.715 200.977L259.56 207.702C259.639 208.429 259.639 209.196 259.639 209.934C259.639 211.379 259.393 212.854 258.902 214.309L257.604 218.192H275.95",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.458 203.956H270.867",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_5363_18058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.23 318.177L316.048 284.314C313.718 282.35 313.287 278.925 315.058 276.445C317.042 273.667 320.973 273.173 323.583 275.372L363.765 309.235C366.095 311.199 366.526 314.624 364.755 317.104C362.771 319.882 358.84 320.376 356.23 318.177Z",
    fill: "#102D3E",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 231.5C342 276.511 305.511 313 260.5 313C215.489 313 179 276.511 179 231.5C179 186.489 215.489 150 260.5 150C305.511 150 342 186.489 342 231.5ZM260.5 301.364C299.085 301.364 330.364 270.085 330.364 231.5C330.364 192.915 299.085 161.636 260.5 161.636C221.915 161.636 190.636 192.915 190.636 231.5C190.636 270.085 221.915 301.364 260.5 301.364Z",
    fill: "#0999B9",
    stroke: "#102D3E",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_5363_18058",
    x: 80,
    y: 86,
    width: 161,
    height: 219.967,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5363_18058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5363_18058",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect2_foregroundBlur_5363_18058"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_df_5363_18058",
    x: 140,
    y: 126,
    width: 161,
    height: 219.967,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5363_18058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5363_18058",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect2_foregroundBlur_5363_18058"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5363_18058",
    x: 80,
    y: 90,
    width: 246,
    height: 289.954,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5363_18058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5363_18058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_5363_18058",
    x: 178,
    y: 149,
    width: 198.844,
    height: 183.553,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.178196 0 0 0 0 0.243137 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5363_18058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5363_18058",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinances);
export default __webpack_public_path__ + "static/media/Finances.719e3cef823d7b2f43102ce96b3bfa4c.svg";
export { ForwardRef as ReactComponent };